/**
 * @module builder
 */
import type { UpdateableProduct } from '../..'

export function calculateMaterial(product: UpdateableProduct): UpdateableProduct {
  const { quantity, price } = product

  const updatedPrice = quantity * (price.useCustom ? price.custom : price.default)

  return {
    ...product,
    totalPrice: {
      ...product.totalPrice,
      default: Number.isNaN(updatedPrice) ? 0 : updatedPrice
    }
  }
}
